import { render, staticRenderFns } from "./yaoyiyao.vue?vue&type=template&id=d979a512&scoped=true&"
import script from "./yaoyiyao.vue?vue&type=script&lang=js&"
export * from "./yaoyiyao.vue?vue&type=script&lang=js&"
import style0 from "./yaoyiyao.vue?vue&type=style&index=0&id=d979a512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d979a512",
  null
  
)

export default component.exports